/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC, useEffect } from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { PrivateRoutes } from "./PrivateRoutes";
import { ErrorsPage } from "../modules/errors/ErrorsPage";
import { Logout, AuthPage, useAuth } from "../modules/auth";
import { App } from "../App";
import Campaigns from "../pages/campaign/campaignPoster";
import Winner from "../pages/campaign/winnerPage";
import PDFViewer from "../pages/campaign/pdfViewer";
import CustomWinner from "../pages/campaign/customWinner";

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env;

const AppRoutes: FC = () => {
  const { currentUser } = useAuth();

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<App />}>
          <Route path="error/*" element={<ErrorsPage />} />
          <Route path="logout" element={<Logout />} />
          {currentUser ? (
            <>
              <Route path="/*" element={<PrivateRoutes />} />
              <Route index element={<Navigate to="/dashboard" />} />
            </>
          ) : (
            <>
              <Route path="auth/*" element={<AuthPage />} />
              {/* <Route path='campaigns' element={<Campaigns />} />
              <Route path='winnerPage' element={<Winner />} />
              <Route path='customWinnerPage' element={<CustomWinner />} />
              <Route path='terms_conditions' element={<PDFViewer />} /> */}
              <Route path="*" element={<Navigate to="/auth" />} />
            </>
          )}
          <Route path="campaigns" element={<Campaigns />} />
          <Route path="winnerPage" element={<Winner />} />
          <Route path="customWinnerPage" element={<CustomWinner />} />
          <Route path="terms_conditions" element={<PDFViewer />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export { AppRoutes };
